(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 54722:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(77167);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ AuthGuard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/utils/_enums/authStrategies.enum.ts
var authStrategies_enum = __webpack_require__(94449);
// EXTERNAL MODULE: ./src/utils/_hooks/useMounted.hook.ts
var useMounted_hook = __webpack_require__(35339);
// EXTERNAL MODULE: ./src/components/_shared/header-footer-wrapper/header-footer-wrapper.tsx
var header_footer_wrapper = __webpack_require__(3143);
// EXTERNAL MODULE: ./node_modules/react-spinners-kit/lib/index.js
var lib = __webpack_require__(79608);
// EXTERNAL MODULE: ./src/components/_shared/spacer/spacer.tsx
var spacer = __webpack_require__(4363);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/_shared/loading/loading.module.scss
var loading_module = __webpack_require__(92591);
var loading_module_default = /*#__PURE__*/__webpack_require__.n(loading_module);
;// CONCATENATED MODULE: ./src/components/_shared/loading/loading.tsx






/**
 * An Loading React Component.
 * @author
 * @version 0.1
 */ var Loading = function(param) {
    var text = param.text, textDe = param.textDe;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (loading_module_default()).loading,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CircleSpinner, {
                size: 100,
                color: "#000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                height: "20px"
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                height: "5px"
            }),
            textDe && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                children: textDe
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next-data-hooks/index.esm.js
var index_esm = __webpack_require__(4118);
// EXTERNAL MODULE: ./src/utils/_config/axios.ts
var axios = __webpack_require__(79098);
;// CONCATENATED MODULE: ./src/api/hooks/useNotAuthorizedPage.hook.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useNotAuthorizedPage = (0,index_esm/* createDataHook */.Qo)("AuthGuardPage", function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var locale, ref, localeRes, result, ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = param.locale;
                    ;
                    localeRes = !locale || locale === "catchAll" ? "en" : locale;
                    _ctx.next = 5;
                    return (0,axios/* backend */.y)().get("api/strapi/confirmation-pages?_locale=".concat(localeRes, "&urlReadablePageTitle=").concat(getNotAuthorizedPageName(localeRes)));
                case 5:
                    result = _ctx.sent;
                    ;
                    return _ctx.abrupt("return", (ref1 = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : null);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
var getNotAuthorizedPageName = function(locale) {
    switch(locale){
        case "de":
            return "zugriff-verweigert";
        case "en":
            return "access-restricted";
        default:
            return "access-restricted";
    }
};

// EXTERNAL MODULE: ./src/utils/_enums/article-page-types.tsx
var article_page_types = __webpack_require__(88092);
// EXTERNAL MODULE: ./src/views/article-page/article-page.tsx + 15 modules
var article_page = __webpack_require__(82997);
;// CONCATENATED MODULE: ./src/components/_shared/auth-guard/auth-guard-error/auth-guard-error.tsx





var AuthGuardError = function() {
    var data = useNotAuthorizedPage();
    if (data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_page/* ArticlePage */.D, {
            type: article_page_types/* ArticlePageTypes.CONFIRMATION_PAGE */.W.CONFIRMATION_PAGE,
            pageData: data
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
AuthGuardError.dataHooks = [
    useNotAuthorizedPage
];

;// CONCATENATED MODULE: ./src/components/_shared/auth-guard/auth-guard.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









var AuthGuard = function(param) {
    var strategies = param.strategies, children = param.children;
    var dispatch = (0,es/* useDispatch */.I0)();
    var hasMounted = (0,useMounted_hook/* useMounted */.s)().hasMounted;
    var ref1 = (0,redux/* useAppSelector */.CG)(function(state) {
        var ref;
        return {
            hasRegistered: state.authentification.hasRegistered,
            loginPending: state.authentification.pending,
            fetchUserPending: state.userSlice.fetchUser.pending,
            jwt: state.authentification.jwt,
            registerConfirmed: state.authentification.hasConfirmedRegistration,
            showCheckoutConfirmation: state.checkoutSlice.showCheckoutConfirmation,
            instanceInCart: state.checkoutSlice.basket,
            maxCheckoutTime: state.checkoutSlice.maxTime,
            role: (ref = state.userSlice.user) === null || ref === void 0 ? void 0 : ref.role.type,
            fetchCurrentProductModelStatus: state.checkoutSlice.fetchCurrentProductModelStatus,
            authRoutingActive: state.authentification.authRoutingActive
        };
    }), hasRegistered = ref1.hasRegistered, jwt = ref1.jwt, registerConfirmed = ref1.registerConfirmed, showCheckoutConfirmation = ref1.showCheckoutConfirmation, instanceInCart = ref1.instanceInCart, maxCheckoutTime = ref1.maxCheckoutTime, role = ref1.role, fetchCurrentProductModelStatus = ref1.fetchCurrentProductModelStatus, loginPending = ref1.loginPending, fetchUserPending = ref1.fetchUserPending, authRoutingActive = ref1.authRoutingActive;
    (0,react.useEffect)(function() {
        if (!hasMounted) return;
        if ((strategies === null || strategies === void 0 ? void 0 : strategies.includes(authStrategies_enum/* AuthStrategies.INSTANCE_IN_CART */.k.INSTANCE_IN_CART)) && !instanceInCart && jwt) {
            dispatch((0,redux/* fetchCurrentProduct */.FF)());
        }
    }, [
        hasMounted,
        jwt
    ]);
    (0,react.useEffect)(function() {
        if (fetchCurrentProductModelStatus) {
            dispatch((0,redux/* resetFetchCurrentProductState */.yb)());
        }
    }, [
        fetchCurrentProductModelStatus
    ]);
    var checkValidAuth = function(strategy) {
        switch(strategy){
            case authStrategies_enum/* AuthStrategies.REGISTERED */.k.REGISTERED:
                {
                    return hasRegistered;
                }
            case authStrategies_enum/* AuthStrategies.IS_ADMIN */.k.IS_ADMIN:
                {
                    return role === "admin";
                }
            case authStrategies_enum/* AuthStrategies.IS_BOOKKEEPER */.k.IS_BOOKKEEPER:
                {
                    return role === "bookkeeper";
                }
            case authStrategies_enum/* AuthStrategies.REGISTER_CONFIRMED */.k.REGISTER_CONFIRMED:
                {
                    return registerConfirmed !== undefined;
                }
            case authStrategies_enum/* AuthStrategies.UNAUTHORIZED */.k.UNAUTHORIZED:
                {
                    return !jwt;
                }
            case authStrategies_enum/* AuthStrategies.BOUGHT */.k.BOUGHT:
                {
                    return showCheckoutConfirmation;
                }
            case authStrategies_enum/* AuthStrategies.INSTANCE_IN_CART */.k.INSTANCE_IN_CART:
                {
                    return instanceInCart === undefined || maxCheckoutTime === undefined ? false : Boolean(instanceInCart) && maxCheckoutTime - Math.floor((new Date(instanceInCart.currentTimeStamp).getTime() - new Date(instanceInCart.createdAt).getTime()) / 1000) > 0;
                }
            case authStrategies_enum/* AuthStrategies.USER */.k.USER:
                {
                    return fetchUserPending || loginPending && !jwt ? undefined : Boolean(jwt);
                }
        }
    };
    if (!hasMounted) {
        return null;
    }
    if (authRoutingActive) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {
            text: "",
            textDe: ""
        });
    }
    if (strategies) {
        var pending = strategies.some(function(strategy) {
            return checkValidAuth(strategy) === undefined;
        });
        var valid = strategies.every(function(strategy) {
            return checkValidAuth(strategy);
        });
        if (pending) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {
                text: "",
                textDe: ""
            });
        } else if (valid) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthGuardError, {});
        }
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
AuthGuard.defaultProps = {
    strategies: [
        authStrategies_enum/* AuthStrategies.USER */.k.USER
    ]
};
AuthGuard.dataHooks = _toConsumableArray(header_footer_wrapper/* HeaderFooterWrapper.dataHooks */.u.dataHooks).concat(_toConsumableArray(AuthGuardError.dataHooks));


/***/ }),

/***/ 77167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var router = __webpack_require__(80880);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/_shared/auth-guard/auth-guard.tsx + 3 modules
var auth_guard = __webpack_require__(81461);
// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/utils/_enums/authStrategies.enum.ts
var authStrategies_enum = __webpack_require__(94449);
// EXTERNAL MODULE: ./src/utils/_enums/route-path.enum.tsx
var route_path_enum = __webpack_require__(16837);
// EXTERNAL MODULE: ./src/api/hooks/useRegisterPage.hook.ts
var useRegisterPage_hook = __webpack_require__(7589);
// EXTERNAL MODULE: ./src/components/_shared/faq-box/faq-box.tsx
var faq_box = __webpack_require__(29795);
// EXTERNAL MODULE: ./src/components/_shared/header/default-header/default-header.tsx + 9 modules
var default_header = __webpack_require__(4302);
// EXTERNAL MODULE: ./src/components/_shared/header-footer-wrapper/header-footer-wrapper.tsx
var header_footer_wrapper = __webpack_require__(3143);
// EXTERNAL MODULE: ./src/components/_shared/link/link.tsx
var link_link = __webpack_require__(46164);
// EXTERNAL MODULE: ./src/components/_shared/meta-tags-resolver/meta-tags-resolver.tsx
var meta_tags_resolver = __webpack_require__(66743);
// EXTERNAL MODULE: ./src/components/_shared/stage/stage.tsx
var stage = __webpack_require__(70818);
// EXTERNAL MODULE: ./src/components/_shared/text-section/text-section.tsx
var text_section = __webpack_require__(29209);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/api/hooks/useCurrentLanguage.hook.ts + 1 modules
var useCurrentLanguage_hook = __webpack_require__(91785);
// EXTERNAL MODULE: ./src/utils/_enums/button-types.enum.tsx
var button_types_enum = __webpack_require__(30830);
// EXTERNAL MODULE: ./src/utils/_helper/enum-to-language-mapper.tsx
var enum_to_language_mapper = __webpack_require__(15487);
// EXTERNAL MODULE: ./src/utils/_helper/input-validation.tsx
var input_validation = __webpack_require__(27788);
// EXTERNAL MODULE: ./src/utils/_helper/valid-country-helper.tsx
var valid_country_helper = __webpack_require__(63720);
// EXTERNAL MODULE: ./src/components/_shared/checkbox/checkbox.tsx
var checkbox_checkbox = __webpack_require__(25977);
// EXTERNAL MODULE: ./src/components/_shared/input-fields/input/input.tsx
var input = __webpack_require__(17850);
// EXTERNAL MODULE: ./src/components/_shared/select/select.tsx
var select_select = __webpack_require__(39382);
// EXTERNAL MODULE: ./src/components/register/register-form/register-form.module.scss
var register_form_module = __webpack_require__(97412);
var register_form_module_default = /*#__PURE__*/__webpack_require__.n(register_form_module);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/register/register-form/register-form-submit-button/register-form-submit-button.module.scss
var register_form_submit_button_module = __webpack_require__(32211);
var register_form_submit_button_module_default = /*#__PURE__*/__webpack_require__.n(register_form_submit_button_module);
;// CONCATENATED MODULE: ./src/components/register/register-form/register-form-submit-button/register-form-submit-button.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var AuthenticationFormSubmitButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (register_form_submit_button_module_default())["authentication-form-submit-button-wrapper"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, _objectSpread({}, props))
    });
};

;// CONCATENATED MODULE: ./src/components/register/register-form/register-form.tsx
function register_form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function register_form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            register_form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


















var RegisterForm = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var data1 = (0,useRegisterPage_hook/* useRegisterPage */.Q)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var language = (0,useCurrentLanguage_hook/* useCurrentLanguage */.U)();
    var ref15 = (0,redux/* useAppSelector */.CG)(function(state) {
        return {
            registerStatePending: state.authentification.pending,
            hasRegistered: state.authentification.hasRegistered
        };
    }), registerStatePending = ref15.registerStatePending, hasRegistered = ref15.hasRegistered;
    var countryOptions = enum_to_language_mapper/* EnumToLanguageMapper.countriesMapping */.H.countriesMapping().filter(function(param) {
        var value = param.value;
        return (0,valid_country_helper/* isValidGeoIp */.g)(value.toLowerCase());
    });
    (0,react.useEffect)(function() {
        dispatch((0,redux/* setHasRegistered */.gU)(false));
    }, []);
    var ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var schema = yup_es/* object */.Ry({
        country: yup_es/* string */.Z_().required((ref16 = data1 === null || data1 === void 0 ? void 0 : (ref = data1.country) === null || ref === void 0 ? void 0 : (ref1 = ref.fieldErrorMessages) === null || ref1 === void 0 ? void 0 : ref1.required) !== null && ref16 !== void 0 ? ref16 : ""),
        email: yup_es/* string */.Z_().required((ref17 = data1 === null || data1 === void 0 ? void 0 : (ref2 = data1.email) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fieldErrorMessages) === null || ref3 === void 0 ? void 0 : ref3.required) !== null && ref17 !== void 0 ? ref17 : "").email((ref18 = data1 === null || data1 === void 0 ? void 0 : (ref4 = data1.email) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fieldErrorMessages) === null || ref5 === void 0 ? void 0 : ref5.valid) !== null && ref18 !== void 0 ? ref18 : ""),
        username: yup_es/* string */.Z_().max(16, (ref19 = data1 === null || data1 === void 0 ? void 0 : (ref6 = data1.username) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fieldErrorMessages) === null || ref7 === void 0 ? void 0 : ref7.max) !== null && ref19 !== void 0 ? ref19 : "").required((ref20 = data1 === null || data1 === void 0 ? void 0 : (ref8 = data1.username) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fieldErrorMessages) === null || ref9 === void 0 ? void 0 : ref9.required) !== null && ref20 !== void 0 ? ref20 : ""),
        password: input_validation/* InputValidation.password */.h.password((ref21 = data1 === null || data1 === void 0 ? void 0 : (ref10 = data1.password) === null || ref10 === void 0 ? void 0 : ref10.fieldErrorMessages) !== null && ref21 !== void 0 ? ref21 : {
            id: -1,
            required: ""
        }),
        confirmPassword: yup_es/* string */.Z_().oneOf([
            yup_es/* ref */.iH("password"),
            null
        ], (ref22 = data1 === null || data1 === void 0 ? void 0 : (ref11 = data1.confirmPassword) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.fieldErrorMessages) === null || ref12 === void 0 ? void 0 : ref12.valid) !== null && ref22 !== void 0 ? ref22 : ""),
        agbConfirmed: yup_es/* boolean */.O7().oneOf([
            true
        ], (ref23 = data1 === null || data1 === void 0 ? void 0 : (ref13 = data1.agbAdvancedAccept) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.fieldErrorMessages) === null || ref14 === void 0 ? void 0 : ref14.required) !== null && ref23 !== void 0 ? ref23 : "")
    });
    var resolver = (0,yup_module/* yupResolver */.X)(schema);
    var ref24 = (0,index_esm/* useForm */.cI)({
        resolver: resolver,
        mode: "onChange"
    }), register = ref24.register, handleSubmit = ref24.handleSubmit, control = ref24.control, errors = ref24.formState.errors;
    var dataSubmitted = function(data) {
        dispatch((0,redux/* createUser */.r4)(register_form_objectSpread({}, data, {
            language: language.toUpperCase()
        })));
    };
    if (data1) {
        var ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            noValidate: true,
            className: (register_form_module_default())["authentification-form"],
            onSubmit: handleSubmit(dataSubmitted),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                    register: register,
                    title: data1 === null || data1 === void 0 ? void 0 : (ref25 = data1.email) === null || ref25 === void 0 ? void 0 : ref25.fieldLabel,
                    type: "email",
                    name: "email",
                    placeholder: data1 === null || data1 === void 0 ? void 0 : (ref26 = data1.email) === null || ref26 === void 0 ? void 0 : ref26.fieldHint,
                    errorMessage: (ref27 = errors) === null || ref27 === void 0 ? void 0 : (ref28 = ref27["email"]) === null || ref28 === void 0 ? void 0 : ref28.message
                }, "email-input"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                    register: register,
                    title: data1 === null || data1 === void 0 ? void 0 : (ref29 = data1.username) === null || ref29 === void 0 ? void 0 : ref29.fieldLabel,
                    type: "username",
                    name: "username",
                    placeholder: data1 === null || data1 === void 0 ? void 0 : (ref30 = data1.username) === null || ref30 === void 0 ? void 0 : ref30.fieldHint,
                    errorMessage: (ref31 = errors) === null || ref31 === void 0 ? void 0 : (ref32 = ref31["username"]) === null || ref32 === void 0 ? void 0 : ref32.message
                }, "username-input"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                    register: register,
                    name: "password",
                    title: data1 === null || data1 === void 0 ? void 0 : (ref33 = data1.password) === null || ref33 === void 0 ? void 0 : ref33.fieldLabel,
                    placeholder: data1 === null || data1 === void 0 ? void 0 : (ref34 = data1.password) === null || ref34 === void 0 ? void 0 : ref34.fieldHint,
                    errorMessage: (ref35 = errors) === null || ref35 === void 0 ? void 0 : (ref36 = ref35["password"]) === null || ref36 === void 0 ? void 0 : ref36.message,
                    type: "password"
                }, "password-input"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                    register: register,
                    name: "confirmPassword",
                    title: data1 === null || data1 === void 0 ? void 0 : (ref37 = data1.confirmPassword) === null || ref37 === void 0 ? void 0 : ref37.fieldLabel,
                    placeholder: data1 === null || data1 === void 0 ? void 0 : (ref38 = data1.confirmPassword) === null || ref38 === void 0 ? void 0 : ref38.fieldHint,
                    errorMessage: (ref39 = errors) === null || ref39 === void 0 ? void 0 : (ref40 = ref39["confirmPassword"]) === null || ref40 === void 0 ? void 0 : ref40.message,
                    type: "password"
                }, "confirm-password-input"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, {
                    control: control,
                    label: data1 === null || data1 === void 0 ? void 0 : (ref41 = data1.country) === null || ref41 === void 0 ? void 0 : ref41.fieldLabel,
                    name: "country",
                    placeholder: data1 === null || data1 === void 0 ? void 0 : (ref42 = data1.country) === null || ref42 === void 0 ? void 0 : ref42.fieldHint,
                    errorMessage: (ref43 = errors) === null || ref43 === void 0 ? void 0 : (ref44 = ref43["country"]) === null || ref44 === void 0 ? void 0 : ref44.message,
                    options: countryOptions
                }, "country-input"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                    register: register,
                    name: "agbConfirmed",
                    errorMessage: (ref45 = errors) === null || ref45 === void 0 ? void 0 : (ref46 = ref45["agbConfirmed"]) === null || ref46 === void 0 ? void 0 : ref46.message,
                    children: data1 === null || data1 === void 0 ? void 0 : (ref47 = data1.agbAdvancedAccept) === null || ref47 === void 0 ? void 0 : ref47.fieldLabel
                }, "agb-checkbox"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                    register: register,
                    name: "newsletterConfirmed",
                    children: data1 === null || data1 === void 0 ? void 0 : (ref48 = data1.newsletterAccept) === null || ref48 === void 0 ? void 0 : ref48.fieldLabel
                }, "newsletter-checkbox"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                    register: register,
                    name: "dropletterConfirmed",
                    children: data1 === null || data1 === void 0 ? void 0 : (ref49 = data1.dropletterAccept) === null || ref49 === void 0 ? void 0 : ref49.fieldLabel
                }, "dropletter-checkbox"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticationFormSubmitButton, {
                    pending: registerStatePending || hasRegistered,
                    type: button_types_enum/* ButtonTypesEnum.SUBMIT */.J.SUBMIT,
                    children: data1 === null || data1 === void 0 ? void 0 : (ref50 = data1.registerButton) === null || ref50 === void 0 ? void 0 : ref50.buttonText
                }, "register-submit-button")
            ]
        });
    } else {
        return null;
    }
};

// EXTERNAL MODULE: ./src/utils/_hooks/hooks.tsx
var hooks = __webpack_require__(62251);
// EXTERNAL MODULE: ./src/views/register/register-page.module.scss
var register_page_module = __webpack_require__(72195);
var register_page_module_default = /*#__PURE__*/__webpack_require__.n(register_page_module);
;// CONCATENATED MODULE: ./src/views/register/register-page.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















var AuthentificationPage = function() {
    var data = (0,useRegisterPage_hook/* useRegisterPage */.Q)();
    var hasRegistered = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.authentification.hasRegistered;
    });
    (0,react.useEffect)(function() {
        if (hasRegistered) {
            router_default().push(data === null || data === void 0 ? void 0 : data.registerThankYouURL);
        }
    }, [
        hasRegistered
    ]);
    if (data) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
        var ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(header_footer_wrapper/* HeaderFooterWrapper */.u, {
            className: (register_page_module_default())["authentification-page"],
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(default_header/* DefaultHeader */.y, {
                availableLanguages: data === null || data === void 0 ? void 0 : data.localizations
            }),
            stage: /*#__PURE__*/ (0,jsx_runtime.jsx)(stage/* Stage */.H, {
                orientation: (ref20 = data === null || data === void 0 ? void 0 : (ref = data.stage) === null || ref === void 0 ? void 0 : (ref1 = ref.componentStyles) === null || ref1 === void 0 ? void 0 : ref1.textAlign) !== null && ref20 !== void 0 ? ref20 : "LEFT",
                inverted: (ref21 = data === null || data === void 0 ? void 0 : (ref2 = data.stage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.componentStyles) === null || ref3 === void 0 ? void 0 : ref3.inverted) !== null && ref21 !== void 0 ? ref21 : false,
                background: data === null || data === void 0 ? void 0 : (ref4 = data.stage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.background) === null || ref5 === void 0 ? void 0 : ref5.url,
                title: (ref22 = data === null || data === void 0 ? void 0 : (ref6 = data.stage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.headline) === null || ref7 === void 0 ? void 0 : ref7.headlineContent) !== null && ref22 !== void 0 ? ref22 : "",
                titleVariant: (ref8 = data.stage) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.headline) === null || ref9 === void 0 ? void 0 : ref9.style,
                logo: (ref23 = data === null || data === void 0 ? void 0 : (ref10 = data.stage) === null || ref10 === void 0 ? void 0 : ref10.showLogo) !== null && ref23 !== void 0 ? ref23 : false,
                description: (ref24 = data.stage.paragraph.content) !== null && ref24 !== void 0 ? ref24 : "",
                size: "Small"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(meta_tags_resolver/* MetaTagsResolver */.H, {
                    tags: data.meta
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (register_page_module_default())["authentification-page-upper-wrapper"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_section/* default */.Z, {
                                    title: (ref25 = data === null || data === void 0 ? void 0 : (ref11 = data.registerHeader) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.title) === null || ref12 === void 0 ? void 0 : ref12.headlineContent) !== null && ref25 !== void 0 ? ref25 : "",
                                    description: (ref26 = data === null || data === void 0 ? void 0 : (ref13 = data.registerHeader) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.description) === null || ref14 === void 0 ? void 0 : ref14.content) !== null && ref26 !== void 0 ? ref26 : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (register_page_module_default())["login-link"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        href: route_path_enum/* RoutePath.LOGIN */.h3.LOGIN,
                                        children: data.loginLinkText
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_section/* default */.Z, {
                                    title: data === null || data === void 0 ? void 0 : (ref15 = data.registerFormText) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.title) === null || ref16 === void 0 ? void 0 : ref16.headlineContent,
                                    description: data === null || data === void 0 ? void 0 : (ref17 = data.registerFormText) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.description) === null || ref18 === void 0 ? void 0 : ref18.content
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (register_page_module_default())["authentification-page-lower-wrapper"],
                    children: data === null || data === void 0 ? void 0 : (ref19 = data.faqbox) === null || ref19 === void 0 ? void 0 : ref19.map(function(param) {
                        var Headline = param.Headline, fa_qs = param.fa_qs;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(faq_box/* default */.Z, {
                            Headline: Headline !== null && Headline !== void 0 ? Headline : "",
                            fa_qs: fa_qs !== null && fa_qs !== void 0 ? fa_qs : []
                        }, (ref27 = Headline === null || Headline === void 0 ? void 0 : Headline.headlineContent) !== null && ref27 !== void 0 ? ref27 : "");
                    })
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
AuthentificationPage.dataHooks = [
    useRegisterPage_hook/* useRegisterPage */.Q
].concat(_toConsumableArray(meta_tags_resolver/* MetaTagsResolver.dataHooks */.H.dataHooks));

;// CONCATENATED MODULE: ./src/pages/register.tsx








var AuthentificationPagePage = function() {
    var jwt = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.authentification.jwt;
    });
    (0,react.useEffect)(function() {
        if (jwt) {
            router_default().push(route_path_enum/* RoutePath.MY_ACCOUNT */.h3.MY_ACCOUNT + route_path_enum/* AccountRoutePath.PROFILE */.ql.PROFILE);
        }
    }, [
        jwt
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_guard/* AuthGuard */.a, {
        strategies: [
            authStrategies_enum/* AuthStrategies.UNAUTHORIZED */.k.UNAUTHORIZED
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthentificationPage, {})
    });
};
var __N_SSP = true;
/* harmony default export */ var register = (AuthentificationPagePage);


/***/ }),

/***/ 94449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ AuthStrategies; }
/* harmony export */ });
var AuthStrategies;
(function(AuthStrategies) {
    AuthStrategies[AuthStrategies["USER"] = 0] = "USER";
    AuthStrategies[AuthStrategies["REGISTERED"] = 1] = "REGISTERED";
    AuthStrategies[AuthStrategies["REGISTER_CONFIRMED"] = 2] = "REGISTER_CONFIRMED";
    AuthStrategies[AuthStrategies["UNAUTHORIZED"] = 3] = "UNAUTHORIZED";
    AuthStrategies[AuthStrategies["BOUGHT"] = 4] = "BOUGHT";
    AuthStrategies[AuthStrategies["INSTANCE_IN_CART"] = 5] = "INSTANCE_IN_CART";
    AuthStrategies[AuthStrategies["IS_ADMIN"] = 6] = "IS_ADMIN";
    AuthStrategies[AuthStrategies["IS_BOOKKEEPER"] = 7] = "IS_BOOKKEEPER";
})(AuthStrategies || (AuthStrategies = {}));


/***/ }),

/***/ 27788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ InputValidation; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var InputValidation = /*#__PURE__*/ function() {
    "use strict";
    function InputValidation() {
        _classCallCheck(this, InputValidation);
    }
    InputValidation.password = function password(errorMessages) {
        return yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.required).min(12, errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.min).matches(/.*[?=)(/&%$§“!_@-]+.*/, errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.valid).matches(/.*\d+.*/, errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.valid).matches(/.*[A-ZÄÖÜ]+.*/, errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.valid).matches(/.*[a-zäöü]+.*/, errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.valid);
    };
    return InputValidation;
}();


/***/ }),

/***/ 92591:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__d8D7D"};

/***/ }),

/***/ 32211:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","authentication-form-submit-button-wrapper":"register-form-submit-button_authentication-form-submit-button-wrapper__WAyMc"};

/***/ }),

/***/ 97412:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","authentification-form":"register-form_authentification-form__C6Ygy","create-wallet-link":"register-form_create-wallet-link__ZoVue"};

/***/ }),

/***/ 72195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","authentification-page-upper-wrapper":"register-page_authentification-page-upper-wrapper__ZkNDR","login-link":"register-page_login-link___Yl0Z","authentification-page-lower-wrapper":"register-page_authentification-page-lower-wrapper__8kzNv"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4577,9866,6586,8760,6067,855,725,6188,8043,1526,1556,2888,179], function() { return __webpack_exec__(54722); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);